interface IPollingProps {
    getSharedCartState: () => Promise<void>;
    duration: number;
    delay: number;
    resumeWithDelay?: boolean;
}

export class GroupCartStatusPoller {
    private _running = false;
    private timeoutRef: number | null = null;

    private static _instance: GroupCartStatusPoller | null = null;

    stop(): void {
        this._running = false;
        this.timeoutRef && clearTimeout(this.timeoutRef);
        GroupCartStatusPoller._instance = null;
    }

    static getInstance(): GroupCartStatusPoller | null {
        return GroupCartStatusPoller._instance;
    }

    async enableGroupCartPolling(props: IPollingProps) {
        GroupCartStatusPoller._instance?.stop();
        GroupCartStatusPoller._instance = this;

        this._running = true;

        if (props.resumeWithDelay) {
            await this.waitForNextPoll(props.delay);
        }

        this.pollSharedCartInfo(props);
    }

    private async pollSharedCartInfo(props: IPollingProps) {
        if (!this._running) return;

        const currentTime = window.performance.now();
        const _endTime = currentTime + props.duration;
        while (currentTime < _endTime && this._running) {
            await props.getSharedCartState();
            await this.waitForNextPoll(props.delay);
        }
    }

    private waitForNextPoll(time: number): Promise<void> {
        return new Promise((resolve, _) => {
            this.timeoutRef = (setTimeout(resolve, time) as unknown) as number;
        });
    }
}
